var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#0191FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87 6.79C9.87 6.5 9.97 6.255 10.17 6.055C10.38 5.855 10.64 5.755 10.95 5.755C11.27 5.755 11.525 5.855 11.715 6.055C11.915 6.255 12.015 6.5 12.015 6.79C12.015 7.07 11.915 7.315 11.715 7.525C11.525 7.725 11.27 7.825 10.95 7.825C10.64 7.825 10.38 7.725 10.17 7.525C9.97 7.315 9.87 7.07 9.87 6.79ZM10.02 12.04H11.88V15.97C11.8 16 11.685 16.025 11.535 16.045C11.385 16.075 11.22 16.09 11.04 16.09C10.7 16.09 10.445 16.03 10.275 15.91C10.105 15.78 10.02 15.555 10.02 15.235V12.04ZM11.88 12.985H10.02V8.965C10.1 8.935 10.215 8.91 10.365 8.89C10.525 8.86 10.695 8.845 10.875 8.845C11.225 8.845 11.48 8.91 11.64 9.04C11.8 9.16 11.88 9.385 11.88 9.715V12.985Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.653313352558991922b0c13a40056d1f.svg";
export { ForwardRef as ReactComponent };